import { make } from 'vuex-pathify'
import axios from 'axios'
import { getQueryFromFilter, showError, showSuccess } from '@/util/helpers'

const state = {
  group: {
    active: true,
  },
  groups: {
    data: [],
    count: 0,
    limit: 25,
  },
  variants: {
    data: [],
  },
  filter: {
    page: 1,
    itemsPerPage: 25,
    sortBy: ['name'],
    sortDesc: [false],
  },
  dialog: false,
  loading: false,
}

const mutations = make.mutations(state)

const actions = {
  open: ({ state, dispatch }) => {
    state.dialog = true
    return dispatch('get')
  },

  get: ({ state }, filter = state.filter) => {
    state.loading = true
    return axios.get(`${process.env.VUE_APP_API_URL}/product-group?${getQueryFromFilter(filter)}`)
      .then(res => {
        state.groups = res.data
        return res.data
      })
      .catch(showError)
      .finally(() => {
        state.loading = false
      })
  },

  save: ({ state, dispatch }, group) => {
    const id = group.id
    const method = id ? 'put' : 'post'

    state.loading = true
    return axios[method](`${process.env.VUE_APP_API_URL}/product-group/${id || ''}`, group)
      .then(res => {
        showSuccess('Grupo salvo com sucesso!')
        dispatch('get')
        return res.data
      })
      .catch(showError)
      .finally(() => {
        state.loading = false
      })
  },

  remove: ({ state, dispatch }, id) => {
    state.loading = true
    return axios.delete(`${process.env.VUE_APP_API_URL}/product-group/${id}`)
      .then(() => {
        showSuccess('Grupo excluído com sucesso!')
        dispatch('get')
      })
      .catch(showError)
      .finally(() => {
        state.loading = false
      })
  },

  getVariants: ({ state }, groupId) => {
    state.loading = true
    return axios.get(`${process.env.VUE_APP_API_URL}/product-group/${groupId}/variants?${getQueryFromFilter({})}`)
      .then(res => {
        state.variants = res.data
        return res.data
      })
      .catch(showError)
      .finally(() => {
        state.loading = false
      })
  },

  saveVariant: ({ state, dispatch }, { groupId, variant }) => {
    const id = variant.id
    const method = id ? 'put' : 'post'
    const path = id
      ? `/product-group/${groupId}/variants/${id}`
      : `/product-group/${groupId}/variants`

    state.loading = true
    return axios[method](`${process.env.VUE_APP_API_URL}${path}?${getQueryFromFilter({})}`, variant)
      .then(res => {
        showSuccess('Variação salva com sucesso!')
        dispatch('getVariants', groupId)
        dispatch('get')
        return res.data
      })
      .catch(showError)
      .finally(() => {
        state.loading = false
      })
  },

  unlinkVariant: ({ state, dispatch }, { groupId, productId }) => {
    state.loading = true
    return axios.delete(`${process.env.VUE_APP_API_URL}/product-group/${groupId}/variants/${productId}?${getQueryFromFilter({})}`)
      .then(() => {
        showSuccess('Variação desvinculada com sucesso!')
        dispatch('getVariants', groupId)
        dispatch('get')
      })
      .catch(showError)
      .finally(() => {
        state.loading = false
      })
  },

  syncVariants: ({ state, dispatch }, { groupId, data }) => {
    state.loading = true
    return axios.post(`${process.env.VUE_APP_API_URL}/product-group/${groupId}/sync-variants?${getQueryFromFilter({})}`, data)
      .then(res => {
        showSuccess('Dados aplicados nas variações!')
        dispatch('getVariants', groupId)
        return res.data
      })
      .catch(showError)
      .finally(() => {
        state.loading = false
      })
  },
}

const getters = make.getters(state)

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
}
